import { AfterViewInit, Component, EventEmitter, inject, Input, Output, signal, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';

@Component({
  selector: 'lib-web-shared-ui-lib-franchise',
  imports: [MatFormFieldModule, MatInputModule, MatButtonModule, FormsModule],
  templateUrl: './lib-franchise.component.html',
  styleUrl: './lib-franchise.component.scss',
})
export class LibFranchiseComponent implements AfterViewInit {
  @ViewChild('franchiseForm') form!: NgForm;
  franchiseFormSignal = signal<any>({
    name: '',
    lastname: '',
    tel: '',
    email: '',
    website: '',
  });

  @Output() emitFormData = new EventEmitter();

  private readonly loggingService = inject(LoggingService);

  showMessageSuccess = signal<boolean>(false);

  // emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$/;
  emailPattern = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9]+\.[a-zA-Z0-9]+$/;

  // Pattern for names: A-Z, a-z, Thai (ก-ฮ, ะ-์), special chars, and spaces (no leading/trailing spaces)
  namePattern = /^[a-zA-Z\u0E01-\u0E4F\s.'-]+$/;

  ngAfterViewInit() {
    this.form.valueChanges!.subscribe((res) => {
      if (res.tel && !this.isOnlyNumbers(res.tel)) {
        // Remove non-numeric characters from `tel`
        const numericValue = res.tel.replace(/[^0-9]/g, '');
        this.form.controls['tel'].setValue(numericValue, { emitEvent: false });
      }

      // Sanitize name field - trim and collapse multiple spaces
      if (res.name) {
        const sanitizedName = this.sanitizeName(res.name);
        if (sanitizedName !== res.name) {
          this.form.controls['name'].setValue(sanitizedName, { emitEvent: false });
        }
      }

      // Sanitize lastname field - trim and collapse multiple spaces
      if (res.lastname) {
        const sanitizedLastname = this.sanitizeName(res.lastname);
        if (sanitizedLastname !== res.lastname) {
          this.form.controls['lastname'].setValue(sanitizedLastname, { emitEvent: false });
        }
      }
    });
  }

  // Checks if the string contains only numbers
  isOnlyNumbers(value: string): boolean {
    return /^[0-9]*$/.test(value);
  }

  // Sanitize name: collapse multiple consecutive spaces to single (don't trim while typing)
  sanitizeName(value: string): string {
    // Only collapse consecutive spaces to single space (not trim - user might be typing new word)
    return value.replace(/  +/g, ' ');
  }

  manageFranchise() {
    //for honeypot input
    if (this.form.value.website) {
      this.loggingService.log('honeypot input', this.form.value.website);
      this.resetForm();
      return;
    }

    this.loggingService.log('FormGroupDirective', !this.form.invalid);
    if (!this.form.invalid) {
      // Trim leading/trailing spaces before emitting
      const formValue = {
        ...this.form.value,
        name: this.form.value.name?.trim(),
        lastname: this.form.value.lastname?.trim(),
      };
      this.emitFormData.emit(formValue);
      this.resetForm();
      this.showMessageSuccess.set(true);
      setTimeout(() => {
        this.showMessageSuccess.set(false);
      }, 4000);
    }
  }

  resetForm() {
    this.franchiseFormSignal.set({
      name: '',
      lastname: '',
      tel: '',
      email: '',
      website: '',
    });
    this.form.resetForm();
  }
}
